<app-layout>
    <mat-toolbar class="page-header" role="heading">
      <h1>{{ 'BasicHeadcountReport' | translate: {Default: "Headcount Report"} }}</h1>
    </mat-toolbar>
  
    <div class="content">
        <app-headcount-report-data-grid></app-headcount-report-data-grid>
    </div>
</app-layout>